import * as yup from "yup";

export const deletionValidationSchema = confirmationText =>
  yup.object({
    confirmationText: yup.string().required("").oneOf([confirmationText], ""),
  });
